// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["form", "submit"]

  initialize() {
    this.formTarget.addEventListener('change', (e) => this.submitForm() )
  }
  
  
  submitForm() {
    this.submitTarget.click()
  }

  connect() {
  }

  /*
  select() {
    this.displayControls()
  }

  displayControls() {
    if (this.statusValue == "closed") {
      this.statusTarget.style.visibility="visible"
    }
    else {
      this.statusTarget.style.visibility="hidden"
    }
  }
  */
}
